<template>
    <div>
        <div class="w-100 mt-5 mb-10">
            <div class="vendor-list" id="printId">
                <div class="p-3">
                    <div style="font-size: 15px;">
                        <span class="fw-500 mr-1" style="text-transform:capitalize;">Notifications
                        </span>  |  {{total}}  Total
                    </div>
                    <!-- <div class="" v-if="ajaxcall">
                        <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448b" class="text-center w-100 d-flex justify-content-center"/>
                    </div> -->
                    <div v-if="ajaxcall" class="checkoutLoader">
                        <div class="LoaderPlacement">
                                <div class="digi-table-loader">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                        </div>
                    </div>
                    <div @scroll="infinite_scroll" id="lazy-load-notify">
                        <div :class="{'notifaction-read':item.is_read,'notifaction-unread':!item.is_read}" class="p-2 mt-2 px-2" v-for="item in list" :key="item.notification_id">
                            <!-- <div class="row d-flex align-items-center" style="cursor: pointer;" @click="showNotification(item._id,item.is_read,item.notification_id)">
                                <div class="col-lg-1 col-md-2 col-sm-2 d-flex align-items-center justify-content-center">
                                    <img :src="item.profile_pic" :alt="item.message" style="height:50px;width:50px;margin-bottom:3px;margin-right:2px;border-radius:50px;">
                                </div>  
                                <div class="col-lg-11 col-md-10 col-sm-10 d-flex align-items-center justify-content-between">
                                    <div class="text-white"> 
                                        <span class="fw-600 text-white">{{item.message}}</span> 
                                    </div>
                                    <div class="d-flex justify-content-end align-items-center fs-12 fw-500 text-white">{{item.created_time}}</div>
                                </div>
                            </div> -->
                            <div class="d-flex justify-content-between align-items-center" style="cursor: pointer;" @click="showNotification(item._id,item.is_read,item.notification_id)">
                                <div class="d-flex align-items-center pl-3">
                                    <img :src="item.profile_pic" v-if="item.profile_pic" :alt="item.message" style="height:50px;width:50px;margin-bottom:3px;margin-right:2px;border-radius:50px;">
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png" v-else :alt="item.message" style="height:50px;width:50px;margin-bottom:3px;margin-right:2px;border-radius:50px;">
                                    <div class="text-white pl-4 text-capitalize"> 
                                        <span class="fw-600 text-white">{{item.message}}</span> 
                                    </div>
                                </div>
                                <div>
                                    <div class="d-flex justify-content-end align-items-center pr-3 fs-12 fw-500 text-white">{{item.created_time}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="" v-if="loading" id="spinner">
                        <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448b" class="text-center w-100 d-flex justify-content-center"/>
                    </div>
                </div>
            </div>
        </div>
        <notification-view modal_name='notifications-view' v-if="show_notification" :notification_id="notification_id" @hideNotification="hideNotification"></notification-view>
    </div>
</template>
<script>
import notification from '../mixins/notification.js';
const NotificationView = () => import("./NotificationView");
export default {
    mixins:[notification],
    components:{
        NotificationView
    },
    data(){
        return{
            skip:0,
            limit:10,
            search_key:'',
            list:[],
            total:0,
            count:0,
            loading:false,
            infinite_scroll_reached_end:false,
            ajaxcall:false,
            show_notification: false,
            notification_id: ''
        }
    },
    methods:{
        showAll(){
            this.$router.push({ name: "AllNotifications" });
        },
        async showNotification(id,i,notification_id) {
            if(i == false){
                let res = await this.ChangeReadStatus({
                    notifications: [id]
                })
                console.log(res)
            }
            this.show_notification = true;
            this.notification_id = notification_id;
            setTimeout(() => {
                this.$modal.show('notifications-view');
            }, 500);
        },
        hideNotification() {
            this.show_notification = false;
            this.getNotification()
        },
        async getNotification(){
            try {
                this.ajaxcall = true
                let params ={
                    skip: this.skip,
                    limit: this.limit,
                    search_key:this.search_key.trim()
                }
                let res = await this.getNotificationList(params)
                this.list = res.response.notifications
                this.total = res.response.count
                this.count = this.list.length
                this.ajaxcall = false
            } catch (reason) {
                
            }
        },
        // async infinite_scroll() {
        //     try {
        //         this.loading = true
        //         let params ={
        //             skip: this.count,
        //             limit: this.limit,
        //             search_key:this.search_key.trim()
        //         }
        //         let res = await this.getNotificationList(params)
        //         if (res.response.skip == this.count) {
        //             let tempFiles = res.response.notifications
        //             tempFiles.forEach(el => {
        //                 this.list.push(el)
        //             })
        //             this.count += res.response.notifications.length
        //             this.loading = false
        //         }
        //         if (res.response.notifications.length < 10) {
        //             document.getElementById('spinner').style.display = 'none'
        //             this.loading = false
        //         }
        //     } catch (reason) {
                
        //     }
        // },
        async infinite_scroll(e) {
            const {target} = e;
            if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                //this code will run when the user scrolls to the bottom of this div so
                //you could do an api call here to implement lazy loading
                this.loading = true
                let params ={
                    skip: this.count,
                    limit: this.limit,
                    search_key:this.search_key.trim()
                }
                let res = await this.getNotificationList(params)
                if (res.response.skip == this.count) {
                    let tempFiles = res.response.notifications
                    tempFiles.forEach(el => {
                        this.list.push(el)
                    })
                    this.count += res.response.notifications.length
                    this.loading = false
                }
                if (res.response.notifications.length < 10) {
                    document.getElementById('spinner').style.display = 'none'
                    this.loading = false
                }

            }
        },
    },
    mounted(){
        this.getNotification()
        // EventBus.$on('RecallNotification', () => {
        //     console.log('reached notifications')
        //     this.getNotification()
        // })
    }
}
</script>
<style scoped>
#lazy-load-notify {
    height: 690px;
    overflow-y: auto;
    overflow-x: hidden;
    margin-bottom: 30px;
    -ms-overflow-style: none; /* IE 11 */
    scrollbar-width: none; /* Firefox 64 */
}
/* #lazy-load-notify::-webkit-scrollbar {
    width: 0px;
    height: 0px;
} */
.notifaction-unread{
    background-color: #4d8ddd;
    border-radius: 4px;
    font-family: "Poppins", "Helvetica Neue", sans-serif !important;
}
.notifaction-read{
    background-color: #cce3fc;
    border-radius: 4px;
    font-family: "Poppins", "Helvetica Neue", sans-serif !important;
}
.inverse div{
     position: absolute;
     top: 27px;
     width: 11px;
     height: 11px;
     border-radius: 50%;
     background: #fff;
     animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
</style>